import { RichText } from '@/components/ui/RichText'

interface Props {
  id?: string
  text: string | null
}

/** Per-question guidance rendered below the label; nothing when absent (FR-010). */
export function QuestionHelperText({ id, text }: Props) {
  return <RichText id={id} html={text} className="mt-1" />
}
